import React from "react";
import { Flex } from "@chakra-ui/react";
import { useOppTheme } from "./useOppTheme";

/** Up to two initials from a name ("Ada Lovelace" → "AL"). "?" for an empty name. */
export const oppInitials = (name: string) =>
  name.trim().split(/\s+/).filter(Boolean).slice(0, 2).map((w) => w.charAt(0).toUpperCase()).join("") || "?";

/**
 * A round initials badge in one of the brand gradients, picked from the name so a person keeps the same
 * colour everywhere they appear. Decorative (aria-hidden): the name is always written beside it.
 * Used for a task assignee and a team member.
 */
export function OppAvatar({ name, size = 44 }: { name: string; size?: number }) {
  const t = useOppTheme();
  const gradients = [
    t.accentGradient,
    t.successGradient,
    `linear-gradient(135deg, ${t.purple} 0%, ${t.primary} 100%)`,
    `linear-gradient(135deg, ${t.secondary} 0%, ${t.purple} 100%)`,
  ];
  let hash = 0;
  for (let i = 0; i < name.length; i += 1) hash = (hash * 31 + name.charCodeAt(i)) >>> 0;
  return (
    <Flex aria-hidden flexShrink={0} w={`${size}px`} h={`${size}px`} borderRadius="full" bgImage={gradients[hash % gradients.length]}
      color="white" fontWeight="bold" fontSize={size >= 44 ? "md" : "sm"} align="center" justify="center" letterSpacing="0.02em">
      {oppInitials(name)}
    </Flex>
  );
}
